import StyledComponent from 'styled-components';

const bgColor = '#235373';

const Container = StyledComponent.div`
      min-height: 80%;
      overflow-y: scroll;
      padding: 15px 15px;

      .friends-content
      {
        text-align: left;
        width: 100%;
      }
      .template-dropdown {
        margin-top: 25px;
        margin-bottom: 25px;
        width: 100%;
      }
      .friends-title
      {
        color: ${bgColor};
      }
      .preview-title
      {
        color: ${bgColor};
      }
      .create-form
      {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .select-control
			{
				width: 100%

				@media(min-width: 600px)
				{
					width: 25%;
				}
			}
      .select-control-element
			{
				width: 100%
      }
      .main-btn-section
      {
        align-self: flex-end;
      }
      .bottom-section
      {
        flex-direction: row;
      }
      .info-message
      {
       white-space:pre-wrap;
      }
		`;

export { Container };
